var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  require("!!vue-style-loader!css-loader?{\"minimize\":true,\"sourceMap\":true}!../../../node_modules/vue-loader/lib/style-compiler/index?{\"vue\":true,\"id\":\"data-v-1bbf9e89\",\"scoped\":true,\"hasInlineConfig\":false}!sass-loader?{\"sourceMap\":true}!../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./SharedAllotedTimeModal.vue")
}
var Component = require("!../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./SharedAllotedTimeModal.vue"),
  /* template */
  require("!!../../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-1bbf9e89\",\"transformToRequire\":{\"video\":\"src\",\"source\":\"src\",\"img\":\"src\",\"image\":\"xlink:href\"}}!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./SharedAllotedTimeModal.vue"),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-1bbf9e89",
  /* moduleIdentifier (server only) */
  null
)
Component.options.__file = "C:\\Work\\widget\\src\\components\\RsvpEdit\\SharedAllotedTimeModal.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] SharedAllotedTimeModal.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (module.hot) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-1bbf9e89", Component.options)
  } else {
    hotAPI.reload("data-v-1bbf9e89", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/RsvpEdit/SharedAllotedTimeModal.vue
// module id = 1980
// module chunks = 0